// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rlT5","selected":"styles_selected__1bnoY"};